// Main javascript entry point

'use strict';

window.$ = jQuery;

import { Header } from '../_modules/header/header';
import { Footer } from '../_modules/footer/footer';
import { WarningNotice } from '../_modules/warning-notice/warning-notice';
import { AccordionWithColumns } from '../_modules/accordion-with-columns/accordion-with-columns';
import { PromoBlockWithCarousel } from '../_modules/promo-block-with-carousel/promo-block-with-carousel';
import { AccordionBasic } from "../_modules/accordion-basic/accordion-basic";
import { HighlightsAndTestimonials } from "../_modules/highlights-and-testimonials/highlights-and-testimonials";
import { CardCarousel } from "../_modules/card-carousel/card-carousel";
import { SearchMapTable } from "../_modules/search-map-table/search-map-table";
import { Sidebar } from '../_modules/has-sidebar/has-sidebar';
// import 'slick-carousel'; // TODO: Remove this import library needs to be loaded via CDN from DRUPAL file
import SearchGlobal from '../_modules/search-global/search-global';
import SearchGlobalQuick from '../_modules/search-global-quick/search-global-quick';
import ResourceInpageSearch from '../_modules/resource-inpage-search/resource-inpage-search';
// import MapAlgolia from '../_modules/map-algolia/map-algolia';
import MapLocal from '../_modules/map-local/map-local';
//import CalendarAlgolia from '../_modules/calendar-algolia/calendar-algolia';
import HomepageSearch from '../_modules/homepage-search/homepage-search';
import EventsDetails from '../_modules/events-details/events-details';
import { Calendar } from '../_modules/calendar/calendar';
import { HorizontalTabs } from '../_modules/horizontal-tabs/horizontal-tabs';
import { AllBlocks } from '../_modules/all-blocks/all-blocks';
// import 'slick-carousel'; // TODO: Remove this import library needs to be loaded via CDN from DRUPAL file
import CalendarAlgolia from '../_modules/calendar-algolia/calendar-algolia';
import CtaFooterInjected from '../_modules/cta-footer-injected/cta-footer-injected';
import BabyCareRoomAwards from '../_modules/baby-care-room-awards/baby-care-room-awards';
import RichTextBlock from '../_modules/rich-text-block/rich-text-block';
// main.dev4.js
import { BlockDashboardNewsCarousel } from "../_modules/block-dashboard-news-carousel/block-dashboard-news-carousel";
import { MemberNavigation } from "../_modules/member-navigation/member-navigation";
import { BlockVolunteerEvents } from "../_modules/block-volunteer-events/block-volunteer-events";
import { UpcomingEvents } from "../_modules/upcoming-events/upcoming-events";
import { BlockProfessionalDevelopmentProgress } from '../_modules/block-professional-development-progress/block-professional-development-progress';
import BLockAlert from '../_modules/block-alert/block-alert';
import BlockDeadlineEvents from '../_modules/block-deadline-events/block-deadline-events';
import LiveChat from "../_modules/live-chat/live-chat";
// import RedirectToMyaba from "../_modules/redirect-to-myaba/redirect-to-myaba";
import DashboardNavigationByRole from "../_modules/dashboard-navigation-by-role/dashboard-navigation-by-role";
import BlockMemberOnlineEvents from "../_modules/block-member-online-events/block-member-online-events";
import CalendarLocalGroup from "../_modules/calendar-local-group/calendar-local-group";
import ViewGroupNodes from "../_modules/view-group-nodes/view-group-nodes";
import ViewsTable from "../_modules/views-table/views-table";
import CrmContribution from '../_modules/crm-contribution/crm-contribution';
import Product from '../_modules/marketplace/product/product';
import UserLoginForm from "../_modules/user-login-form/user-login-form";
import Marketplace from "../_modules/marketplace/marketplace";
import { Webforms } from '../_modules/webforms/webforms';
import GroupSend  from '../_modules/group-send/group-send';

$(() => {
    new Marketplace();
    new Header();
    new Footer();
    new WarningNotice();
    new AccordionWithColumns();
    new PromoBlockWithCarousel();
    new AccordionBasic();
    new HighlightsAndTestimonials();
    new CardCarousel();
    new SearchMapTable();
    new Sidebar();
    new HorizontalTabs();
    new AllBlocks();
    new HomepageSearch;
    new ResourceInpageSearch;
    // new MapAlgolia;
    new MapLocal;
    new CalendarAlgolia;
    new CtaFooterInjected;
    new EventsDetails;
    new Calendar();
    new BabyCareRoomAwards;
    new RichTextBlock;
    new BlockDashboardNewsCarousel();
    new MemberNavigation();
    new BlockVolunteerEvents();
    new UpcomingEvents();
    new BlockProfessionalDevelopmentProgress();
    new BLockAlert();
    new BlockDeadlineEvents();
    new LiveChat();
    // new RedirectToMyaba();
    new DashboardNavigationByRole();
    new BlockMemberOnlineEvents();
    new CalendarLocalGroup();
    new ViewGroupNodes();
    new ViewsTable();
    new CrmContribution();
    new SearchGlobal;
    new SearchGlobalQuick;
    new Product();
    new UserLoginForm();
    new Webforms();
    new GroupSend();
});
